import React from 'react';
import Icon from '../AppIcon';

const LoadingSpinner = ({ size = 'md', className = '', message = 'Loading...' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="flex flex-col items-center space-y-3">
        <div className={`${sizeClasses?.[size]} animate-spin`}>
          <Icon name="Loader2" size={size === 'sm' ? 16 : size === 'md' ? 32 : size === 'lg' ? 48 : 64} className="text-primary" />
        </div>
        {message && (
          <p className="text-sm text-muted-foreground font-body animate-pulse">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;